function _(n,t,o){t.exports=function(n){return n<0?-1:1}}
//# sourceMappingURL=sign.min.js.map